import { createFetcher } from './fetcher'

const fetcherInstance = createFetcher({ targetEnv: 'client' })
export const { fetcher, setAuthorization, setRequestHeaders, removeAuthorization } = fetcherInstance
